import React from "react";
import moment from "moment";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";

export default class ComponentToPrint extends React.Component {
  render() {
    const {
      reportRows = [],
      searchData = {},
      deductionTypes = [],
      factoryDeductionTypes = []
    } = this.props;

    const cellStyle = {
      border: "1px solid #777",
      fontSize: "9px",
      padding: "4px 6px",
      textAlign: "center",
      verticalAlign: "middle",
      whiteSpace: "nowrap"
    };

    const boldCellStyle = {
      ...cellStyle,
      fontWeight: "bold"
    };

    const headerPluckerStyle = {
      ...boldCellStyle,
      backgroundColor: "#e0f2fe"
    };

    const headerFactoryStyle = {
      ...boldCellStyle,
      backgroundColor: "#dcfce7"
    };

    return (
      <div className="p-3">
        <style>
          {`
            @page {
              size: A4 landscape;
              margin: 8mm;
            }
            table {
              width: 100%;
              border-collapse: collapse;
            }
            .MuiTableCell-root {
              border: 1px solid #999 !important;
              padding: 4px 6px !important;
            }
            thead {
              display: table-header-group;
            }
            tr {
              page-break-inside: avoid;
            }
          `}
        </style>

        <h3>
          <center>
            <u>Deduction Breakdown Report</u>
          </center>
        </h3>

        <div className="row pb-3 pt-2" style={{ fontSize: "11px" }}>
          <div className="col">
            <b>Group: </b>
            {searchData.group || "-"}
          </div>
          <div className="col">
            <b>Operation Entity: </b>
            {searchData.estate || "-"}
          </div>
          <div className="col">
            <b>Collection Point: </b>
            {searchData.division || "All"}
          </div>
          <div className="col">
            <b>From Date: </b>
            {searchData.fromDate || "-"}
          </div>
          <div className="col">
            <b>To Date: </b>
            {searchData.toDate || "-"}
          </div>
        </div>

        <Table size="small" style={{ width: "100%", borderCollapse: "collapse" }}>
          <TableHead>
            <TableRow>
              <TableCell rowSpan={2} style={boldCellStyle}>
                EPF
              </TableCell>
              <TableCell rowSpan={2} style={boldCellStyle}>
                Employee
              </TableCell>
              <TableCell rowSpan={2} style={boldCellStyle}>
                Collection Point
              </TableCell>
              <TableCell rowSpan={2} style={boldCellStyle}>
                Field
              </TableCell>
              <TableCell rowSpan={2} style={boldCellStyle}>
                Plucking Type
              </TableCell>
              <TableCell
                colSpan={4 + deductionTypes.length}
                align="center"
                style={headerPluckerStyle}
              >
                Plucker Collection
              </TableCell>
              <TableCell
                colSpan={3 + factoryDeductionTypes.length}
                align="center"
                style={headerFactoryStyle}
              >
                Factory Weight
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell align="center" style={boldCellStyle}>
                Date
              </TableCell>
              <TableCell align="right" style={boldCellStyle}>
                Original
              </TableCell>
              {deductionTypes.map((type) => (
                <TableCell key={type} align="right" style={boldCellStyle}>
                  {type}
                </TableCell>
              ))}
              <TableCell align="right" style={boldCellStyle}>
                Net Wt
              </TableCell>
              <TableCell align="right" style={boldCellStyle}>
                Rounded
              </TableCell>

              <TableCell align="right" style={boldCellStyle}>
                Original
              </TableCell>
              {factoryDeductionTypes.map((type) => (
                <TableCell key={type} align="right" style={boldCellStyle}>
                  {type}
                </TableCell>
              ))}
              <TableCell align="right" style={boldCellStyle}>
                Net Wt
              </TableCell>
              <TableCell align="right" style={boldCellStyle}>
                Rounded
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {reportRows.map((row, index) => {
              if (row.rowType === "DATA") {
                const factory = row.factoryRow;

                return (
                  <TableRow key={index}>
                    {/* EPF & Employee */}
                    <TableCell style={cellStyle}>
                      {row.pluckerRow?.registrationNumber ?? ""}
                    </TableCell>
                    <TableCell style={cellStyle}>
                      {`${row.pluckerRow?.firstName ?? ""}`.trim()}
                    </TableCell>

                    {/* Collection Point Span */}
                    {row.isFirstDivisionRow && (
                      <TableCell
                        rowSpan={row.divisionRowSpan}
                        align="center"
                        style={{ ...cellStyle, verticalAlign: "middle" }}
                      >
                        {row.division?.collectionPointName ?? ""}
                      </TableCell>
                    )}

                    {/* Field Span */}
                    {row.isFirstFieldRow && (
                      <TableCell
                        rowSpan={row.fieldRowSpan}
                        align="center"
                        style={{ ...cellStyle, verticalAlign: "middle" }}
                      >
                        {row.fieldGroup?.fieldName ?? ""}
                      </TableCell>
                    )}

                    <TableCell style={cellStyle}>
                      {row.pluckerRow?.pluckingType ?? ""}
                    </TableCell>

                    {/* ---------- Plucker Details ---------- */}
                    <TableCell align="center" style={cellStyle}>
                      {row.pluckerRow
                        ? moment(row.pluckerRow.collectionDate).format("DD/MM/YYYY")
                        : ""}
                    </TableCell>
                    <TableCell align="right" style={cellStyle}>
                      {row.pluckerRow?.pluckingOriginal ?? 0}
                    </TableCell>
                    {deductionTypes.map((type) => (
                      <TableCell key={type} align="right" style={cellStyle}>
                        {row.pluckerRow?.deductions?.[type] ?? 0}
                      </TableCell>
                    ))}
                    <TableCell align="right" style={cellStyle}>
                      {row.pluckerRow?.netAmount ?? 0}
                    </TableCell>
                    <TableCell align="right" style={cellStyle}>
                      {row.pluckerRow?.rounded ?? 0}
                    </TableCell>

                    {/* ---------- Factory Details (Only when factoryRow exists & spans date within field) ---------- */}
                    {factory && (
                      <>
                        <TableCell
                          rowSpan={row.dateRowSpan}
                          align="right"
                          style={{ ...cellStyle, verticalAlign: "top" }}
                        >
                          {factory.factoryOriginal ?? 0}
                        </TableCell>
                        {factoryDeductionTypes.map((type) => (
                          <TableCell
                            key={type}
                            rowSpan={row.dateRowSpan}
                            align="right"
                            style={{ ...cellStyle, verticalAlign: "top" }}
                          >
                            {factory.deductions?.[type] ?? 0}
                          </TableCell>
                        ))}
                        <TableCell
                          rowSpan={row.dateRowSpan}
                          align="right"
                          style={{ ...cellStyle, verticalAlign: "top" }}
                        >
                          {factory.factoryNet ?? 0}
                        </TableCell>
                        <TableCell
                          rowSpan={row.dateRowSpan}
                          align="right"
                          style={{ ...cellStyle, verticalAlign: "top" }}
                        >
                          {factory.rounded ?? 0}
                        </TableCell>
                      </>
                    )}
                  </TableRow>
                );
              }

              if (row.rowType === "DIVISION_TOTAL") {
                return (
                  <TableRow key={index} style={{ backgroundColor: "#f5f5f5" }}>
                    <TableCell colSpan={6} align="center" style={boldCellStyle}>
                      TOTAL
                    </TableCell>
                    <TableCell align="right" style={boldCellStyle}>
                      {row.plucker.original.toFixed(2)}
                    </TableCell>
                    {deductionTypes.map((type) => (
                      <TableCell key={type} align="right" style={boldCellStyle}>
                        {(row.plucker.deductions?.[type] ?? 0).toFixed(2)}
                      </TableCell>
                    ))}
                    <TableCell align="right" style={boldCellStyle}>
                      {row.plucker.net.toFixed(2)}
                    </TableCell>
                    <TableCell align="right" style={boldCellStyle}>
                      {row.plucker.rounded}
                    </TableCell>

                    <TableCell align="right" style={boldCellStyle}>
                      {row.factory.original.toFixed(2)}
                    </TableCell>
                    {factoryDeductionTypes.map((type) => (
                      <TableCell key={type} align="right" style={boldCellStyle}>
                        {(row.factory.deductions?.[type] ?? 0).toFixed(2)}
                      </TableCell>
                    ))}
                    <TableCell align="right" style={boldCellStyle}>
                      {row.factory.net.toFixed(2)}
                    </TableCell>
                    <TableCell align="right" style={boldCellStyle}>
                      {row.factory.rounded}
                    </TableCell>
                  </TableRow>
                );
              }

              if (row.rowType === "GRAND_TOTAL") {
                return (
                  <TableRow key={index} style={{ backgroundColor: "#e0e0e0" }}>
                    <TableCell colSpan={6} align="center" style={boldCellStyle}>
                      GRAND TOTAL
                    </TableCell>
                    <TableCell align="right" style={boldCellStyle}>
                      {row.plucker.original.toFixed(2)}
                    </TableCell>
                    {deductionTypes.map((type) => (
                      <TableCell key={type} align="right" style={boldCellStyle}>
                        {(row.plucker.deductions?.[type] ?? 0).toFixed(2)}
                      </TableCell>
                    ))}
                    <TableCell align="right" style={boldCellStyle}>
                      {row.plucker.net.toFixed(2)}
                    </TableCell>
                    <TableCell align="right" style={boldCellStyle}>
                      {row.plucker.rounded}
                    </TableCell>

                    <TableCell align="right" style={boldCellStyle}>
                      {row.factory.original.toFixed(2)}
                    </TableCell>
                    {factoryDeductionTypes.map((type) => (
                      <TableCell key={type} align="right" style={boldCellStyle}>
                        {(row.factory.deductions?.[type] ?? 0).toFixed(2)}
                      </TableCell>
                    ))}
                    <TableCell align="right" style={boldCellStyle}>
                      {row.factory.net.toFixed(2)}
                    </TableCell>
                    <TableCell align="right" style={boldCellStyle}>
                      {row.factory.rounded}
                    </TableCell>
                  </TableRow>
                );
              }

              return null;
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}